exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".labelTip3{color:hsla(0,0%,45.1%,.87);font-size:1em;margin-top:50px}", ""]);

// exports
